var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.789062 14.5799C0.789062 7.03797 6.90714 0.924057 14.4542 0.924057H105.229C112.777 0.924057 118.895 7.03798 118.895 14.5799V105.294C118.895 112.835 112.777 118.949 105.229 118.949H14.4542C6.90713 118.949 0.789062 112.835 0.789062 105.294V14.5799Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.229 1.89947H14.4542C7.44621 1.89947 1.76514 7.57668 1.76514 14.5799V105.294C1.76514 112.297 7.44621 117.974 14.4542 117.974H105.229C112.237 117.974 117.919 112.297 117.919 105.294V14.5799C117.919 7.57668 112.237 1.89947 105.229 1.89947ZM14.4542 0.924057C6.90714 0.924057 0.789062 7.03797 0.789062 14.5799V105.294C0.789062 112.835 6.90713 118.949 14.4542 118.949H105.229C112.777 118.949 118.895 112.835 118.895 105.294V14.5799C118.895 7.03798 112.777 0.924057 105.229 0.924057H14.4542Z",
    fill: "#6F3DD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1731 20.9378C7.1731 13.4079 13.2814 7.30379 20.8163 7.30379H97.8032C105.338 7.30379 111.446 13.4079 111.446 20.9378V97.8724C111.446 105.402 105.338 111.506 97.8032 111.506H20.8163C13.2814 111.506 7.1731 105.402 7.1731 97.8724V20.9378Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8032 8.27765H20.8163C13.8196 8.27765 8.14761 13.9458 8.14761 20.9378V97.8724C8.14761 104.864 13.8196 110.532 20.8163 110.532H97.8032C104.8 110.532 110.472 104.864 110.472 97.8724V20.9378C110.472 13.9458 104.8 8.27765 97.8032 8.27765ZM20.8163 7.30379C13.2814 7.30379 7.1731 13.4079 7.1731 20.9378V97.8724C7.1731 105.402 13.2814 111.506 20.8163 111.506H97.8032C105.338 111.506 111.446 105.402 111.446 97.8724V20.9378C111.446 13.4079 105.338 7.30379 97.8032 7.30379H20.8163Z",
    fill: "#6F3DD3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0139 130.243C71.0139 129.433 71.6709 128.776 72.4812 128.776H116.501C123.254 128.776 128.728 123.305 128.728 116.557V72.5676C128.728 71.7578 129.385 71.1013 130.195 71.1013C131.006 71.1013 131.663 71.7578 131.663 72.5676V116.557C131.663 124.925 124.874 131.709 116.501 131.709H72.4812C71.6709 131.709 71.0139 131.052 71.0139 130.243Z",
    fill: "#6F3DD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyper);
export default __webpack_public_path__ + "static/media/hyper.654875b178ab7d032fcf28fbc81ed7e8.svg";
export { ForwardRef as ReactComponent };